<template>
  <FlashSalesTag
    v-if="dealContent"
    :icon="dealContent.icon"
    :label="dealContent.label"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconArrowDownRight } from '@ds/icons/IconArrowDownRight'
import { IconBoltFilled } from '@ds/icons/IconBoltFilled'

import type { Deal, Granularity } from '../models/product'

import FlashSalesTag from './FlashSales/FlashSalesTag.vue'
import translations from './ProductCardDeal.translations'

const i18n = useI18n()
const experiments = useExperiments()
const isFlashSalesEnabled = experiments['experiment.flashSales'] === 'enabled'
const isSellerFlashSalesEnabled =
  experiments['experiment.sellerFlashSales'] === 'with'

const { deal, granularity } = defineProps<{
  deal?: Deal
  granularity?: Granularity
}>()

const dealContent = computed(() => {
  if (!deal) return null
  if (isFlashSalesEnabled && deal.type === 'flash_sales')
    return {
      label: i18n(translations.flashSalesTag, {
        price: i18n.price(deal.discount, {
          trailingZeroDisplay: 'stripIfInteger',
        }),
      }),
      icon: IconBoltFilled,
    }
  if (
    isSellerFlashSalesEnabled &&
    granularity === 'backbox' &&
    deal.type === 'seller_flash_sales' &&
    deal.percentage?.value
  ) {
    return {
      label: i18n(translations.sellerFlashSalesTag, {
        percentage: `${deal.percentage.value}%`,
      }),
      icon: IconArrowDownRight,
    }
  }

  return null
})
</script>
